import TalkizyAPI from '@app/services/API/Talkizy';
import { MEETING_LEAD_MINUTES, isMeetingLocked } from '@shared/utils/meeting';

export default {
  methods: {
    editMeetingTitle(meeting, onUpdated) {
      // Verrou d'édition : plus de renommage à moins de MEETING_LEAD_MINUTES du
      // début (classe imminente, en cours ou terminée).
      if (isMeetingLocked(meeting)) {
        this.$buefy.toast.open({
          message: `La classe virtuelle ne peut plus être modifiée à moins de ${MEETING_LEAD_MINUTES} minutes de son début.`,
          type: 'is-warning',
        });
        return;
      }
      this.$buefy.dialog.prompt({
        title: 'Modifier le titre',
        inputAttrs: { value: meeting.title, maxlength: 128, required: true },
        confirmText: 'Valider',
        trapFocus: true,
        onConfirm: (title) => this.renameMeeting(meeting, title, onUpdated),
      });
    },
    async renameMeeting(meeting, title, onUpdated) {
      const name = (title || '').trim();
      if (!name) {
        this.$buefy.toast.open({ message: 'Le titre est requis.', type: 'is-warning' });
        return;
      }
      const loader = this.$buefy.loading.open();
      try {
        // Partial update, like a training rename: only the title is sent.
        const updated = await TalkizyAPI.updateMeeting(meeting.meeting_id, { title: name });
        this.$buefy.toast.open({ message: 'Titre mis à jour.', type: 'is-success' });
        if (onUpdated) {
          onUpdated(updated);
        }
      } catch (e) {
        const message = e?.response?.data?.error || 'La mise à jour a échoué.';
        this.$buefy.toast.open({ message, type: 'is-danger', duration: 6000 });
      } finally {
        loader.close();
      }
    },
  },
};
